import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentBrand, PaymentSimulationScenario } from '@interfaces/';

@Component({
  selector: 'app-payment-simulator-modal',
  templateUrl: './payment-simulator-modal.component.html',
  styleUrls: ['./payment-simulator-modal.component.scss'],
  standalone: false
})
export class PaymentSimulatorModalComponent implements OnInit {
  @Input() amount: number = 0;
  selectedBrand: PaymentBrand = 'VISA';
  selectedScenario: PaymentSimulationScenario = 'success';

  brands: Array<{ value: PaymentBrand; label: string; icon: string }> = [
    { value: 'VISA', label: 'Visa', icon: 'cc-visa' },
    { value: 'MC', label: 'Mastercard', icon: 'cc-mastercard' },
    { value: 'AMEX', label: 'American Express', icon: 'cc-amex' }
  ];

  scenarios: Array<{ value: PaymentSimulationScenario; label: string; icon: string; color: string }> = [
    { value: 'success', label: 'payment_simulator.scenarios.success', icon: 'check-circle', color: 'success' },
    { value: 'declined', label: 'payment_simulator.scenarios.declined', icon: 'times-circle', color: 'danger' },
    { value: 'timeout', label: 'payment_simulator.scenarios.timeout', icon: 'clock', color: 'warning' },
    { value: 'insufficient_funds', label: 'payment_simulator.scenarios.insufficient_funds', icon: 'wallet', color: 'danger' },
    { value: 'invalid_card', label: 'payment_simulator.scenarios.invalid_card', icon: 'credit-card', color: 'danger' },
    { value: 'network_error', label: 'payment_simulator.scenarios.network_error', icon: 'wifi', color: 'warning' },
    { value: 'use_pinpad', label: 'Pago con Pinpad', icon: 'wifi', color: 'success' }
  ];

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
  }

  selectBrand(brand: PaymentBrand): void {
    this.selectedBrand = brand;
  }

  selectScenario(scenario: PaymentSimulationScenario): void {
    this.selectedScenario = scenario;
  }

  confirm(): void {
    this.activeModal.close({
      brand: this.selectedBrand,
      scenario: this.selectedScenario,
      confirmed: true
    });
  }

  cancel(): void {
    this.activeModal.dismiss('cancel');
  }
}

